import { jsxs as V, jsx as i } from "react/jsx-runtime";
import { FlowsAddButton as W } from "../add-button/AddButton.component.js";
import { useBoolean as $, useMergeThemeVariables as L } from "../../shared/utils.js";
import { Modal as R } from "../../shared/modal/Modal.component.js";
import { StepForm as q } from "./StepForm.component.js";
import { useState as b, useCallback as S, useMemo as z } from "react";
import { StepWithArrow as G } from "./StepWithArrow.component.js";
import { Step as M } from "./Step.component.js";
import { FlowArrow as H } from "../flow-arrow/FlowArrow.component.js";
import '../../assets/Steps.css';const J = "_steps_1hici_2", P = "_modal_1hici_7", E = {
  steps: J,
  modal: P
}, Q = ({
  copies: f,
  apiDeclaration: w,
  declaration: t,
  onFlowDeclarationUpdate: r,
  theme: _
}) => {
  const [g, n, x] = $(!1), [v, c] = b(), [l, A] = b(0), C = L("step", M.themeKeys, _), T = S(
    (e) => {
      r({
        ...t,
        steps: {
          ...t.steps,
          [e.id]: e
        }
      }), c(void 0);
    },
    [t, r]
  ), o = z(() => {
    const e = { ...t.steps }, p = [];
    let s = t.startStep;
    for (; s; )
      p.push({ ...e[s], id: s }), s = e[s].nextStep;
    return p;
  }, [t.startStep, t.steps]), j = S(
    (e) => {
      const p = Object.keys(t.steps).filter((m) => m.startsWith(e.type)).reduce((m, u) => {
        const N = parseInt(u.replace(e.type, ""));
        return N > m ? N : m;
      }, -1) + 1, s = `${e.type}${p}`;
      if (l === 0) {
        r({
          ...t,
          startStep: s,
          steps: {
            [s]: { ...e, nextStep: t.startStep },
            ...t.steps
          }
        });
        return;
      }
      const d = o[l - 1], h = o[l];
      r({
        ...t,
        startStep: t.startStep || s,
        steps: {
          ...t.steps,
          [d.id]: {
            ...d,
            nextStep: s
          },
          [s]: {
            ...e,
            nextStep: (h == null ? void 0 : h.id) ?? null
          }
        }
      });
    },
    [t, l, r, o]
  ), k = S(
    (e) => {
      const { [e]: p, ...s } = t.steps, d = p.nextStep, h = Object.fromEntries(
        Object.entries(s).map(([m, u]) => u.nextStep === e ? [m, { ...u, nextStep: d }] : [m, u])
      );
      r({
        ...t,
        startStep: t.startStep === e ? d : t.startStep,
        steps: h
      });
    },
    [t, r]
  ), B = S(
    (e) => {
      c(e), n();
    },
    [n]
  ), y = S(() => {
    c(void 0), x();
  }, [x]), K = S(() => {
    A(0), n();
  }, [n]), O = S(
    (e, p) => {
      A(p + 1), n();
    },
    [n]
  ), I = S(() => {
    A(o.length), n();
  }, [o.length, n]);
  return /* @__PURE__ */ V("div", { className: E.steps, children: [
    /* @__PURE__ */ i(
      H,
      {
        withButton: o.length > 0,
        onClick: K,
        label: f.then
      }
    ),
    o.map((e, p) => /* @__PURE__ */ i(
      G,
      {
        index: p,
        step: e,
        copies: f,
        isLast: p === o.length - 1,
        onDelete: k,
        onEdit: B,
        onAddNewStepAfter: O,
        apiDeclaration: w,
        theme: C
      },
      e.id
    )),
    /* @__PURE__ */ i(W, { copy: f.add, onClick: I }),
    g && /* @__PURE__ */ i(R, { onClose: y, className: E.modal, children: /* @__PURE__ */ i(
      q,
      {
        onEditStep: T,
        editedStep: v,
        copies: f,
        onClose: y,
        apiDeclaration: w,
        declaration: t,
        onAddStep: j
      }
    ) })
  ] });
}, X = Q;
X.themeKeys = {
  ...M.themeKeys,
  step: !0
};
export {
  X as Steps
};
